import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

var _GIGYA_SORT_VALUES_CA;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import reduce from 'lodash/reduce';
import serviceSDK from '@nerdwallet/nw-api-sdk/service-sdk';

require('es6-promise').polyfill();

var ServiceSDK = serviceSDK({
  clientID: process.env.CLIENT_ID,
  applicationID: 'nerdwallet web',
  identityBaseUrl: process.env.IDENTITY_BASE_URL
});
export var GIGYA_RATINGS_LOADED = 'GIGYA_RATINGS_LOADED';
export var GIGYA_COMMENTS_LOADED = 'GIGYA_COMMENTS_LOADED';
export var GIGYA_COMMENTS_LOADING = 'GIGYA_COMMENTS_LOADING';
export var GIGYA_COMMENT_POSTING = 'GIGYA_COMMENT_POSTING';
export var GIGYA_COMMENT_POSTED = 'GIGYA_COMMENT_POSTED';
export var GIGYA_COMMENT_POSTED_FAIL = 'GIGYA_COMMENT_POSTED_FAIL';
export var GIGYA_COMMENT_VOTING = 'GIGYA_COMMENT_VOTING';
export var GIGYA_COMMENT_VOTED = 'GIGYA_COMMENT_VOTED';
export var GIGYA_COMMENT_VOTED_FAIL = 'GIGYA_COMMENT_VOTED_FAIL';
export var GIGYA_LOGIN = 'GIGYA_LOGIN';
export var GIGYA_LOGOUT = 'GIGYA_LOGOUT';
export var GIGYA_LOADED = 'GIGYA_LOADED';
export var SET_USER_COMMENT = 'SET_USER_COMMENT';
export var POST_LOGIN_ACTIONS = 'POST_LOGIN_ACTIONS';
export var POST_LOGIN_ACTIONS_COMPLETE = 'POST_LOGIN_ACTIONS_COMPLETE'; // If category is blank, the review is a Credit Card review

var getPostCommentEndpoint = function getPostCommentEndpoint() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var origin = process.env.FINPRO_BASE_URL;
  var path = '/review/v1/comments/';
  return "".concat(origin).concat(path).concat(category);
};

export var GIGYA_SORT_VALUES = {
  DATE_DESC: 'dateDesc',
  DATE_ASC: 'dateAsc',
  RATING_DESC: 'ratingDesc',
  VOTES_DESC: 'votesDesc'
};
export var GIGYA_DEFAULT_SORT_VALUE = GIGYA_SORT_VALUES.DATE_DESC;
export var GIGYA_SORT_VALUES_CANONICAL = (_GIGYA_SORT_VALUES_CA = {}, _defineProperty(_GIGYA_SORT_VALUES_CA, GIGYA_SORT_VALUES.DATE_DESC, 'Most recent'), _defineProperty(_GIGYA_SORT_VALUES_CA, GIGYA_SORT_VALUES.DATE_ASC, 'Oldest'), _defineProperty(_GIGYA_SORT_VALUES_CA, GIGYA_SORT_VALUES.RATING_DESC, 'Ratings'), _defineProperty(_GIGYA_SORT_VALUES_CA, GIGYA_SORT_VALUES.VOTES_DESC, 'Most voted'), _GIGYA_SORT_VALUES_CA); // Retrives user info if already logged in via social

export var getUserInfo = function getUserInfo(gigya) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      if (get(gigya, 'user.UID')) {
        return resolve(gigya.user);
      }

      if (!gigya || !gigya.socialize) {
        return false;
      }

      return gigya.socialize.getUserInfo({
        callback: function callback(response) {
          if (!response.errorCode && get(response, 'user.UID')) {
            dispatch({
              type: GIGYA_LOGIN,
              user: response.user
            });
            resolve(response.user);
          } else {
            reject(response.errorMessage);
          }
        }
      });
    });
  };
};
export var gigyaLoaded = function gigyaLoaded(gigya) {
  return function (dispatch) {
    return dispatch({
      type: GIGYA_LOADED,
      gigya: gigya
    });
  };
};
export var fetchGigyaUserComments = function fetchGigyaUserComments(streamID) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var _getState = getState(),
          gigya = _getState.gigya;

      if (!gigya || !gigya.comments) {
        return;
      }

      var params = {
        categoryID: 'Credit Card Reviews',
        streamID: streamID,
        callback: function callback() {
          var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (response.errorCode) {
            reject(response.errorMessage);
          } else if (response.commentCount > 0) {
            dispatch({
              type: SET_USER_COMMENT,
              // We only allow users to post one comment per product, so only return the first
              comment: get(response, 'comments[0]')
            });
          }

          resolve({
            comment: get(response, 'comments[0]', {})
          });
        }
      };
      gigya.comments.getUserComments(params);
    });
  };
};
export var postLoginActions = function postLoginActions(commentStreamID) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        gigya = _getState2.gigya;

    var actionsToFire = [];

    if (!gigya || !gigya.user || gigya.postLoginActionsInProgress) {
      return false;
    }

    dispatch({
      type: POST_LOGIN_ACTIONS
    });

    if (commentStreamID) {
      actionsToFire.push(dispatch(fetchGigyaUserComments(commentStreamID)));
    }

    return Promise.all(actionsToFire).then(function () {
      return dispatch({
        type: POST_LOGIN_ACTIONS_COMPLETE
      });
    });
  };
};
export var onGigyaLoaded = function onGigyaLoaded(gigya, commentStreamID) {
  return function (dispatch) {
    return dispatch(getUserInfo(gigya)).catch(function (err) {
      console.warn(err || 'Gigya: no logged in user info found');
      return true;
    }).then(function () {
      return dispatch(gigyaLoaded(gigya));
    }).then(function () {
      return dispatch(postLoginActions(commentStreamID));
    });
  };
};
export var fetchGigyaRatings = function fetchGigyaRatings(streamIDs, categoryID) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        gigya = _getState3.gigya;

    if (!gigya || !gigya.comments) {
      return;
    }

    gigya.comments.getStreamInfo({
      categoryID: categoryID,
      streamIDs: streamIDs,
      includeRatingDetails: true,
      callback: function callback() {
        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!response.errorCode) {
          dispatch({
            type: GIGYA_RATINGS_LOADED,
            ratings: reduce(response.streamInfo, function (result, rating) {
              return _objectSpread({}, result, _defineProperty({}, rating.streamID, rating));
            }, {})
          });
        }
      }
    });
  };
};
export var fetchGigyaComments = function fetchGigyaComments(streamID, sort, clearCurrentComments) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        gigya = _getState4.gigya;

    if (!gigya || !gigya.comments) {
      return;
    }

    if (gigya.loading) {
      return;
    }

    var params = {
      streamID: streamID,
      sort: sort || GIGYA_DEFAULT_SORT_VALUE,
      categoryID: 'Credit Card Reviews',
      callback: function callback() {
        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!response.errorCode) {
          dispatch({
            type: GIGYA_COMMENTS_LOADED,
            streamID: streamID,
            clearCurrentComments: clearCurrentComments,
            comments: _defineProperty({}, streamID, response.comments),
            hasMoreComments: response.hasMore,
            nextCommentsTimestamp: response.next
          });
        }
      }
    };

    if (gigya.hasMoreComments && gigya.nextCommentsTimestamp) {
      params.start = gigya.nextCommentsTimestamp;
    }

    dispatch({
      type: GIGYA_COMMENTS_LOADING
    });
    gigya.comments.getComments(params);
  };
};
export var login = function login(gigya, provider) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      if (!gigya || !gigya.socialize) {
        return;
      }

      gigya.socialize.login({
        provider: provider,
        callback: function callback(response) {
          if (!response.errorCode) {
            dispatch({
              type: GIGYA_LOGIN,
              user: response.user
            });
            resolve(response);
          } else {
            reject(response.errorMessage);
          }
        }
      });
    });
  };
};
export var logout = function logout() {
  return function (dispatch, getState) {
    var _getState5 = getState(),
        gigya = _getState5.gigya;

    if (!gigya || !gigya.socialize) {
      return;
    }

    gigya.socialize.logout({
      callback: function callback(response) {
        if (!response.errorCode) {
          dispatch({
            type: GIGYA_LOGOUT
          });
        }
      }
    });
  };
};
export var postCommentHelper = function postCommentHelper(params) {
  return function (dispatch, getState) {
    var _getState6 = getState(),
        gigya = _getState6.gigya;

    if (!gigya || gigya.posting) {
      return;
    }

    if (gigya.postedComment) {
      dispatch({
        type: GIGYA_COMMENT_POSTED_FAIL,
        error: 'You have already posted a review.'
      });
    } else {
      dispatch({
        type: GIGYA_COMMENT_POSTING
      });
      ServiceSDK.post(getPostCommentEndpoint(), {
        slug: params.streamID,
        comment_text: params.body,
        comment_title: params.title,
        ratings: params.rating,
        uid: params.UID,
        cardholder_status: params.cardholderStatus
      }, function (err, serverResponse, body) {
        if (err || serverResponse.statusCode !== 200 || get(body, 'data.errorCode') && get(body, 'data.errorCode') !== 0) {
          var errorMessage = get(body, 'data.errorDetails') ? "".concat(get(body, 'data.errorMessage', 'Error'), ": ").concat(get(body, 'data.errorDetails')) : '';
          dispatch({
            type: GIGYA_COMMENT_POSTED_FAIL,
            error: errorMessage
          });
        } else {
          dispatch({
            type: GIGYA_COMMENT_POSTED,
            comment: get(body, 'data.comment')
          });
        }
      });
    }
  };
};
export var postComment = function postComment(params) {
  return function (dispatch, getState) {
    var _getState7 = getState(),
        gigya = _getState7.gigya;

    if (!gigya || gigya.posting) {
      return;
    }

    if (!params.provider && gigya.user) {
      dispatch(postCommentHelper(params));
    } else {
      dispatch(login(gigya, params.provider)).then(function (response) {
        if (!response.errorCode) {
          dispatch(postLoginActions(params.streamID)).then(function () {
            return dispatch(postCommentHelper(params));
          });
        } else {
          dispatch({
            type: GIGYA_COMMENT_POSTED_FAIL,
            error: response.errorMessage
          });
        }
      });
    }
  };
};
export var voteCommentHelper = function voteCommentHelper(params) {
  return function (dispatch, getState) {
    var _getState8 = getState(),
        gigya = _getState8.gigya;

    if (!gigya || !gigya.comments || gigya.voting) {
      return;
    }

    dispatch({
      type: GIGYA_COMMENT_VOTING
    });
    var commentParams = {
      commentID: params.commentID,
      streamID: params.streamID,
      vote: params.vote,
      voteButtonPressed: params.voteButtonPressed,
      allowNegativeVotes: params.allowNegativeVotes
    };

    var paramsToPass = _objectSpread({
      categoryID: 'Credit Card Reviews'
    }, commentParams, {
      callback: function callback(response) {
        if (!response.errorCode) {
          dispatch(_objectSpread({
            type: GIGYA_COMMENT_VOTED
          }, commentParams));
        } else {
          dispatch({
            type: GIGYA_COMMENT_VOTED_FAIL,
            error: response.errorMessage
          });
        }
      }
    });

    gigya.comments.vote(paramsToPass);
  };
};
export var voteComment = function voteComment(params) {
  return function (dispatch, getState) {
    var _getState9 = getState(),
        gigya = _getState9.gigya;

    if (!gigya || gigya.voting) {
      return;
    }

    if (!params.provider && gigya.user) {
      dispatch(voteCommentHelper(params));
    } else {
      dispatch(login(gigya, params.provider)).then(function (response) {
        if (!response.errorCode) {
          dispatch(postLoginActions(params.streamID));
          dispatch(voteCommentHelper(params));
        } else {
          dispatch({
            type: GIGYA_COMMENT_VOTED_FAIL,
            error: response.errorMessage
          });
        }
      });
    }
  };
};